import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';

import { useLanguage } from '../../../Context/LanguageContext';

import CalenderInput from '../../../Component/LockerComponent/LockerCalenderInput';
import RemainDaysInput from '../../../Component/LockerComponent/RemainDaysInput';
import FetchModule from '../../Share/Network/FetchModule';
import AddPaymentOptionModal from '../../../MemberRegistration/Model/AddPaymentOptionModal';
import PaymentOptionSettingSelectBox from '../../../MemberRegistration/Model/PaymentOptionSettingSelectBox';
import PaymentOptionCustomInput from '../../../MemberRegistration/Component/PaymentOptionCustomInput';

import WhiteTrashIcon from '../../../image/WhiteTrashIcon.png';

export default function LockerExtendsModal(props) {
  const { 
    memberData, 
    recentlyMembership,
    lockerRendering,
    lockerData, 
    closeFn 
  } = props;

  const history = useHistory();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const DefaultPaymentOption = [{ id: 0, name: t('main.locker.cash') }, { id: 0, name: t('main.locker.card') }, { id: 0, name: t('main.locker.point') }];

  const [isLoading, setIsLoading] = useState(false);
  const [isClickedAddPaymentOption, setIsClickedAddPaymentOption] = useState(false);
  const [days, setDays] = useState('');
  const [originalEndDate, setOriginalEndDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [placeholder, setPlaceholder] = useState('');
  const [isHoverPrevMembership, setIsHoverPrevMembership] = useState(false);
  const [cardPrice, setCardPrice] = useState(0);
  const [cashPrice, setCashPrice] = useState(0);
  const [point, setPoint] = useState(0);

  const [paymentOptions, setPaymentOptions] = useState([{ id: 0, name: t('main.locker.cash') }, { id: 0, name: t('main.locker.card') }, { id: 0, name: t('main.locker.point') }]);
  const [selectedPaymentOptions, setSelectedPaymentOptions] = useState([{ id: 0, name: t('main.locker.cash'), price: 0 }]);

  // const StartCalenderRef = useRef();
  const EndCalenderRef = useRef();

  // 결제수단 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('payment_option/', 'GET');

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [])

  // Init Data Setting //
  useEffect(() => {
    setOriginalEndDate(lockerData.endDate);
    setEndDate(moment(lockerData.endDate));

    if (moment(lockerData.endDate).format('YYYY.MM.DD') > moment().format('YYYY.MM.DD')) setPlaceholder(t('main.locker.extend.daysLeft').replace('{days}', moment(lockerData.endDate).diff(moment(), 'days') + 1));
    else if (moment(lockerData.endDate).format('YYYY.MM.DD') === moment().format('YYYY.MM.DD')) setPlaceholder('0');
    else return setPlaceholder(t('main.locker.extend.daysOver').replace('{days}', moment().diff(moment(lockerData.endDate), 'days') + 1));
  }, [lockerData])

  
  // 이전 등록 회원권 정보 뷰 정리 //
  function onCalcPrevSalesInfo(className) {
    if (recentlyMembership === undefined || recentlyMembership.prevSales === undefined || recentlyMembership.prevMemberShip === undefined) return '';

    if (className === 'MembershipName') return recentlyMembership.prevSales.itemName;
    else if (className === 'Date') return moment(recentlyMembership.prevUsage.startDate).format('YY.MM.DD') + ' - ' + moment(recentlyMembership.prevUsage.endDate).format('YY.MM.DD');
  }

  // 달력 클릭시 //
  function CalenderClick(className) {
    // if (className === 'StartCalender') EndCalenderRef.current.closeCalender();
    // else StartCalenderRef.current.closeCalender();
  }

  // Days 변경시 //
  function onChangeDays(value) {
    setDays(value);

    if (value === '') setEndDate(moment(originalEndDate));
    else setEndDate(moment(originalEndDate).add(value, 'day'));
    
  }

  // EndDate 변경시 //
  function onChangeEndDate(value) {
    setDays(value.clone().endOf('day').diff(moment(originalEndDate), 'days'));
    setEndDate(value);
  }

  // 결제수단 모달 내에서 결제수단 저장하기 클릭시 //
  function onClickSavePaymentOption(optionName) {
    if (optionName === '') {
      alert(t('main.locker.enterPaymentName'));
      return;
    }

    if (isLoading) {
      alert(t('main.locker.savingInProgress'));
      return;
    }

    setIsLoading(true);

    let requestData = {
      optionName: optionName
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/save', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 결제 수단 삭제버튼 클릭시 //
  function onClickDeleteOption(paymentOptionId) {
    if (isLoading) {
      alert(t('main.locker.deletingInProgress'));
      return;
    }

    setIsLoading(true);

    let requestData = {
      paymentOptionId: paymentOptionId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/delete', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 회원권 결제 수단 변경시 //
  function onChangeSelectedPaymentOptions(data, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions[index].id = data.id;
    newSelectedPaymentOptions[index].name = data.name;

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 금액 변경시 //
  function onChangePaymentOptionPrice(value, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions[index].price = value.replaceAll(',', '');

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 추가 버튼 클릭시 //
  function onClickAddPaymentOptions() {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.push({ id: 0, name: t('main.locker.cash'), price: 0 });

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 제거 버튼 클릭시 //
  function onClickDeletePaymentOptions(index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.splice(index, 1);

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 결제 옵션 추가 버튼 클릭시 //
  function onClickAdditionOption() {
    setIsClickedAddPaymentOption(true);
  }

  // 사용 내역 연장 모달 내에서 저장하기 버튼 클릭시 //
  function onClickSaveExtends() {
    if (isLoading) {
      alert(t('main.locker.extend.extendingInProgress'));
      return;
    }
    else if (moment().clone().format('YYYY-MM-DDTHH:mm:ss') > endDate.clone().format('YYYY-MM-DDTHH:mm:ss')) {
      alert(t('main.locker.extend.cannotBeBeforeToday'));
      return;
    }

    setIsLoading(true);

    let finalCashPrice = 0;
    let finalCardPrice = 0;
    let finalPoint = 0;

    let finalSelectedPaymentOptions = [];

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== ''
        && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
    }


    for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
      if (finalSelectedPaymentOptions[i].id === 0) {
        if (finalSelectedPaymentOptions[i].name === t('main.locker.cash')) finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === t('main.locker.card')) finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      }
    }

    let requestData = {
      lockerId: lockerData.id,
      usageId: lockerData.usageId,
      endDate: endDate.clone().format('YYYY-MM-DDT23:59:59'),
      merchantUid: lockerData.merchantUid,
      cardPrice: finalCardPrice,
      cashPrice: finalCashPrice,
      point: finalPoint,
      lockerPaymentOptions: finalSelectedPaymentOptions
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('locker/extend', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('main.locker.extend.changeComplete'));
          closeFn();
          lockerRendering();
          setIsLoading(false);
        }
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 활성 회원권 정보 클릭시 //
  function onClickPrevMembership() {
    if (recentlyMembership === undefined || recentlyMembership.prevSales === undefined || recentlyMembership.prevMemberShip === undefined) return '';

    let value = moment(recentlyMembership.prevUsage.endDate);
    
    setDays(moment(value.format('YYYY.MM.DD 23:59:59')).diff(moment(), 'days') + 1);
    setEndDate(value);
  }

  return (
    <TotalModalWrapper backgroundColor='rgba(0, 0, 0, 0.3)'>
      {isClickedAddPaymentOption && <AddPaymentOptionModal onClickSave={onClickSavePaymentOption} onClickExit={() => setIsClickedAddPaymentOption(false)} />}
      <Modal>
        <ComponentWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.text} hover='default'>{t('main.locker.extend.title').replace('{name}', '\"' + memberData.name + '\"')}</Text>
          <DivisionLine marginTop={10} marginBottom={10} />
          {
            recentlyMembership !== undefined &&
            <RecentlyMembershipWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('main.locker.extend.activeMembershipInfo')}</Text>
              <RecentlyMembershipInfoWrapper>
                <MembershipInfoWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('main.locker.extend.membership')}</Text>
                  <MembershipNameWrapper
                    onMouseOver={() => setIsHoverPrevMembership(true)}
                    onMouseLeave={() => setIsHoverPrevMembership(false)}
                    onClick={onClickPrevMembership}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isHoverPrevMembership ? theme.primary : theme.text} cursor='pointer'>{onCalcPrevSalesInfo('MembershipName')}</Text>
                  </MembershipNameWrapper>
                </MembershipInfoWrapper>
                <MembershipInfoWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('main.locker.extend.period')}</Text>
                  <MembershipNameWrapper
                    onMouseOver={() => setIsHoverPrevMembership(true)}
                    onMouseLeave={() => setIsHoverPrevMembership(false)}
                    onClick={onClickPrevMembership}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isHoverPrevMembership ? theme.primary : theme.text} cursor='pointer'>{onCalcPrevSalesInfo('Date')}</Text>
                  </MembershipNameWrapper>
                </MembershipInfoWrapper>
              </RecentlyMembershipInfoWrapper>
            </RecentlyMembershipWrapper>
          }
          <LayerWrapper style={{ marginTop: recentlyMembership !== undefined ? `30px` : `20px` }}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('main.locker.extend.lockerNumber')}</Text>
            <InputBox>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{lockerData.lockerName}</Text>
            </InputBox>
          </LayerWrapper>
          <LayerWrapper style={{ marginTop: `13px` }}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('main.locker.extend.memberName')}</Text>
            <InputBox>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{lockerData.userName}</Text>
            </InputBox>
          </LayerWrapper>
          <LayerWrapper style={{ marginTop: `13px` }}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('main.locker.extend.additionalDays')}</Text>
            <DdayInputWrapper>
              <RemainDaysInput value={days} setValue={onChangeDays} placeholder={placeholder} />
            </DdayInputWrapper>
          </LayerWrapper>
          <LayerWrapper style={{ marginTop: `13px` }}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('main.locker.endDate')}</Text>
            <CalenderInput ref={EndCalenderRef} value={endDate} setValue={onChangeEndDate} disabled={false} className='EndCalender' clickFn={CalenderClick} placeholder={t('main.locker.endDate')} width={130} />
          </LayerWrapper>
          <Text style={{ marginTop: '20px', marginBottom: '20px' }} fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} hover='default'>{t('main.locker.extend.additionalAmount')}</Text>
          {
            selectedPaymentOptions.map((data, index) => (
              <InnerLayerWrapper
                key={'SelectedPaymentOptions-' + index}
                marginTop={10}
                gap={10}
                style={{ zIndex: selectedPaymentOptions.length - index }}>
                <SelectOptionInputWrapper>
                  <PaymentOptionTitleWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('main.locker.paymentMethod') + ' ' + (index === 0 ? '' : index + 1)}</Text>
                    {
                      index !== 0 &&
                      <DeleteButton onClick={() => onClickDeletePaymentOptions(index)}>
                        <DeleteIcon src={WhiteTrashIcon} />
                      </DeleteButton>
                    }
                  </PaymentOptionTitleWrapper>
                  <PaymentOptionSettingSelectBox
                    index={index}
                    value={data}
                    setValue={onChangeSelectedPaymentOptions}
                    options={paymentOptions}
                    disabled={paymentOptions.length === 0}
                    width={120}
                    onClickAdditionOption={onClickAdditionOption}
                    onClickDeleteOption={onClickDeleteOption} />
                </SelectOptionInputWrapper>
                <RowDivisionLine />
                <SelectOptionInputWrapper>
                  <PaymentOptionTitleWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('main.locker.receivedPrice')}</Text>
                  </PaymentOptionTitleWrapper>
                  <UnitInputWrapper>
                    <PaymentOptionCustomInput
                      index={index}
                      value={(data.price ?? 0).toLocaleString('ko-KR')}
                      setValue={onChangePaymentOptionPrice}
                      placeholder='0'
                      disabled={false}
                      textAlign='right'
                      width={88} />
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('main.locker.currencyUnit')}</Text>
                  </UnitInputWrapper>
                </SelectOptionInputWrapper>
              </InnerLayerWrapper>
            ))
          }
          <AddPaymentOptionButton onClick={onClickAddPaymentOptions}>{t('main.locker.addPaymentMethod')}</AddPaymentOptionButton>
          <ButtonWrapper>
            <ExitButton onClick={closeFn}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='pointer'>{t('main.locker.cancel')}</Text>
            </ExitButton>
            <SaveButton onClick={onClickSaveExtends}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} hover='pointer'>{t('main.locker.save')}</Text>
            </SaveButton>
          </ButtonWrapper>
        </ComponentWrapper>
      </Modal>
    </TotalModalWrapper>
  )
}

const Modal = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px;

  // width: 323px;
  // // height: 456px;
  // // height: 501px;

  // // border-radius: 30px;
  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 280px;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const RecentlyMembershipWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const RecentlyMembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const MembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 46%;

  gap: 4px;
`;

const MembershipNameWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 20px;

  overflow: hidden;

  &:hover {
    cursor: pointer;
  }
`;

const InputBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 0px 8px;

  width: 114px;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};
`;

const DdayInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 132px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  gap: 16px;

  margin-top: 36px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 5px;
  background-color: ${props => props.theme.subKey};

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.subKeyHover};
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }
`;

const InnerLayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  margin-top: ${props => props.marginTop}px;

  width: 100%;

  gap: ${props => props.gap}px;
`;

const SelectOptionInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const DivisionLine = styled.div`
  margin-top: ${props => props.marginTop}px;
  margin-bottom: ${props => props.marginBottom}px;

  width: 100%;
  height: 1px;

  background-color: ${props => props.theme.line};
`;

const RowDivisionLine = styled.div`
  width: 1px;
  height: 54px;

  background-color: ${props => props.theme.line};
`;

const AddPaymentOptionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  height: 40px;
  
  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.subText};

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.subBackground};
    background-color: ${props => props.theme.subKey};
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 18px;

  border-radius: 2px;
  background-color: ${props => props.theme.pointRedAlpha50};

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.pointRed};
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteIcon = styled.img`
  width: 14px;
  height: 14px;
`;

const PaymentOptionTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;
